import type { Customer, PortfolioItem } from '@app/types';
import {
  AnalyticsActionTypes,
  TrackActionCreator,
  PageViewPayload,
} from './types';

import restructureLegacyProperties from './utils/restructureLegacyProperties';

import {
  IDENTIFY,
  SET_GA,
  PAGEVIEW,
  TRACK,
  TRANSACTION,
  START_LEANPLUM,
} from './consts';

export const identify = ({ id, uuid }) => ({
  type: IDENTIFY,
  payload: {
    uuid,
    id,
  },
});

export const setGA = (payload) => ({
  type: SET_GA,
  payload,
});

export const pageview = ({
  properties,
  decorators,
}: PageViewPayload = {}): AnalyticsActionTypes => ({
  type: PAGEVIEW,
  payload: {
    properties,
    decorators,
  },
});

export const track: TrackActionCreator = ({
  event,
  category,
  label,
  value,
  properties = {},
  decorators = {},
}) => {
  //
  // Translate new to old.
  const formatted = restructureLegacyProperties(properties);

  return {
    type: TRACK,
    payload: {
      event,
      category: category || formatted.category,
      label: label || formatted.label,
      value: value || formatted.value,
      properties: formatted.properties,
      decorators,
    },
  };
};

export const transaction = ({
  portfolioItem,
  customerType,
  customer,
  paymentMethod,
}: {
  portfolioItem: PortfolioItem;
  customerType: 'Buyer' | 'Seller';
  customer: Customer;
  paymentMethod: string | undefined;
}) => ({
  type: TRANSACTION,
  payload: {
    portfolioItem,
    customerType,
    customer,
    paymentMethod,
  },
});

export const startLeanplum = () => ({
  type: START_LEANPLUM,
});
